import gql from 'graphql-tag'

export const QUERY_GET_ACCOUNT_IMAGES = gql`
  query Account {
    account {
      channels {
        hotsite {
          configuration {
            assets {
              images {
                finish {
                  tablet
                  smartphone
                  logo
                  desktop
                }
              }
            }
          }
        }
      }
    }
  }
`
export const QUERY_ACCOUNT = gql`
  query Account {
    account {
      channels {
        hotsite {
          urls
          configuration {
            assets {
              positions {
                formImage
              }
              images {
                home {
                  desktop
                  tablet
                  smartphone
                }
                form {
                  desktop
                  tablet
                  smartphone
                }
                finish {
                  desktop
                  tablet
                  smartphone
                  logo
                }
              }
              colors {
                home {
                  background
                  buttonBackground
                  buttonFont
                  input
                }
                form {
                  buttonBackground
                  buttonFont
                  toolbar
                }
                finish {
                  background
                  buttonBackground
                  buttonFont
                  text
                  main
                }
                legalFooter {
                  background
                  font
                }
                socialNetworksFooter {
                  background
                  font
                }
              }
            }
            fields {
              allowed_person_types_signup
              natural {
                name
                type
                width
                label
                options {
                  label
                  value
                }
                mask
                placeholder
                validators
                backend
                mandatory
              }
              legal {
                name
                type
                width
                label
                options {
                  label
                  value
                }
                mask
                placeholder
                validators
                backend
                mandatory
              }
            }
          }
        }
        ecommerce {
          messages {
            new {
              delivery
              pickup
              recipients
            }
            confirmed {
              delivery
              pickup
            }
            separation {
              delivery
              pickup
            }
            awaiting {
              delivery
              pickup
            }
            concluded {
              delivery
              pickup
            }
            canceled {
              delivery
              pickup
            }
          }
          build {
            url
            colors {
              primary
              font_primary
              secondary
              font_secondary
              tertiary
              font_tertiary
            }
            assets {
              logo
              favicon
            }
          }
        }
      }
    }
  }
`

export const QUERY_URL_IS_AVAILABLE = gql`
  query UrlIsAvailable($url: String!) {
    urlIsAvailable(url: $url)
  }
`

export const QUERY_CONFIGURATION = gql`
  query AppConfiguration {
    configuration: appConfiguration {
      loyalty_terms {
        version
        content
      }
    }
  }
`

export const MUTATION_LOYALTY_TERMS = gql`
  mutation UpdateLoyaltyTerms($version: String!, $content: String!) {
    updateAccountLoyaltyTerms(version: $version, content: $content)
  }
`

export const MUTATION_HOTSITE_CONFIGURATION = gql`
  mutation UpdateHotsiteConfiguration($urls: [String]!, $configuration: AccountHotsiteConfigurationInput!) {
    updateHotsiteConfiguration(urls: $urls, configuration: $configuration)
  }
`

export const MUTATION_SINGLE_UPLOAD = gql`
  mutation SingleUpload($file: Upload!, $prefix: String) {
    singleUpload(file: $file, prefix: $prefix) {
      url
    }
  }
`

export const MUTATION_CREATE_PDV_TOKENS = gql`
  mutation CreatePdvTokens($force: Boolean) {
    createPdvTokens(force: $force)
  }
`

export const MUTATION_CREATE_ECOMMERCE_TOKENS = gql`
  mutation CreateEcommerceToken($force: Boolean, $provider: String!) {
    createEcommerceToken(force: $force, provider: $provider)
  }
`

export const QUERY_INTEGRATION_TOKENS = gql`
  {
    account {
      channels {
        api_integrations {
          token_id
          provider
          token
        }
        ecommerce_integrations {
          tokens {
            provider
            token
          }
        }
      }
    }
  }
`

export const CREATE_API_INTEGRATION_TOKEN = gql`
  mutation CreateAPIIntegration($provider: String!) {
    createAPIIntegration(provider: $provider)
  }
`
